import React from "react";
import "./Footer.css";
import logo from "../assets/images/logo-no-background.png"; // Replace with your logo path
import { FaInstagram, FaFacebook, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left Section: Logo */}
        <div className="footer-logo">
          <img src={logo} alt="Little Smiles Photography" />
        </div>

        {/* Right Section: Social Links */}
        <div className="footer-links">
          <a href="https://instagram.com/littlesmilesphotography.in" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a href="https://wa.me/918050254649" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
          </a>
          {/* <a href="https://facebook.com/supritdk" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a> */}
        </div>
      </div>

      {/* Bottom Section: Copyright */}
      <div className="footer-bottom">
        <p>&copy; 2024-2025 Little Smiles Photography. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
